<template>
    <FormWrapper :is-loading="isLoading">
        <PageTitle title="Messages" slot="title" link="/helpContent/Message List" />
        <ValidationObserver ref="validator" >
            <FormRow>
                <div class="col-sm-3">
                    <InputText v-model="filtering.name" style="width: 200px" label="Search for Records"  />
                </div>
                <div class="col-sm-2" >
                    <FormSelect label="View" :items="viewList" item-name="Name" item-value="Name"  v-model="filtering.selectedView" :onChange="getViews" />
                </div>
                <div class="col-sm-3">
                    <FormButton style="margin-top: 5px" type="primary" @click="search" :rounded="true">
                        <Icon type="ios-search" />
                    </FormButton>
                </div>
            </FormRow>
        </ValidationObserver>
        <DataTable :actions="true"
            :data="messageList"
            :columns="tableConfig"
            :is-loading="isLoading"
            @on-selection-change="selectChange"
            @on-page-change="pageChange"
            :pagination="pagination"
            @on-sort-change="sortChange">
            <template slot="actionsLeft">
                <TableButton @click="() =>view()">
                    <img :src="require(`Assets/images/view.png`)"/>
                    View
                </TableButton>
            </template>
        </DataTable>
        <Popup title="Information" :value="warningModal.visible" @close="() => showWarningModal(false)">
            {{ warningModal.message }}
            <div slot="footer">
                <FormButton v-if="warningModal.buttons.ok" @click="() => showWarningModal(false)">Ok</FormButton>
            </div>
        </Popup>
    </FormWrapper>
</template>

<script>
    import FormWrapper from 'Components/form/FormWrapper';
    import PageTitle from 'Components/layout/PageTitle';
    import DataTable from 'Components/DataTable';
    import validateSelectedRows from "Mixins/validateSelectedRows";
    import loadingMixin from 'Mixins/loadingMixin';
    import {getMessageList} from '../api';
    import tableConfig from './table';
    import { ValidationObserver } from 'vee-validate';
    export default {
        name: "List",
        mixins: [loadingMixin, validateSelectedRows],
        components: {
            FormWrapper,
            DataTable,
            PageTitle,
            ValidationObserver
        },
        data() {
            return {
                filtering: {
                    name: '',
                    viewType: null
                },
                sorting: {
                    key: 'Subject',
                    order: 'asc'
                },
                pagination: {
                    perPage: 10,
                    page: 1,
                    total: 0
                },
                tableConfig,
                messageList: [],
                viewList: [
                    {
                        Name: 'Read'
                    },
                    {
                        Name: 'UnRead'
                    }
                ],
                selectedRows: []
            }
        },
        computed: {
          userData() {
              return this.$store.state.user.user
            }
        },
        watch: {
        },
        created() {
            this.getDataByFilter(this.filtering.selectedView)
        },
        methods: {
            view(){
                if (this.validateSelectedLength(1)) {
                    this.$router.push({ path: `/messageDetails/${btoa(this.selectedRows[0].id)}/${btoa(this.filtering.selectedView)}` });
                }
            },
            selectChange(data) {
                this.selectedRows = data;
            },
            search(){
                this.pagination.page = 1;
                this.getDataByFilter(this.filtering.selectedView)
            },
            sortChange(data) {
                this.sorting.key = data.key;
                this.sorting.order = data.order;
                this.getDataByFilter(this.filtering.selectedView)
            },
            getDataByFilter(ele) {
                setTimeout(() => {
                    this.$refs.validator.validate().then((result) => {
                        if (result) {
                            this.showLoader();
                            const { key, order } = this.sorting;
                            const { perPage, page } = this.pagination;
                            const filters = {};
                            if (this.filtering.name) {
                                filters.searchText = this.filtering.name;
                            }
                            if (ele == undefined) {
                                this.filtering.selectedView='UnRead';
                            } else{
                                this.filtering.selectedView=ele;
                            }
                            if (this.filtering.selectedView) {
                                filters.viewType = this.filtering.selectedView;
                            }
                            const data = {
                                filterjson: {
                                    filter: [filters],
                                    sort: [{ key, order }],
                                    paging: [
                                        {
                                            startIndex: page,
                                            pageSize: perPage
                                        }
                                    ]
                                }
                            };
                            getMessageList(data)
                                .then(this.handleResponse)
                                .catch(this.handleError)
                        }
                    })
                },
                50
                )
            },
            getViews(ele){
                this.getDataByFilter(ele)
            },
            pageChange(page) {
                this.pagination.page = page;
                this.getDataByFilter(this.filtering.selectedView)
            },
            handleResponse(response) {
                this.hideLoader();
                this.messageList = response.data;
                this.pagination.total = response.NumberOfRecords;
            },
        }
    }
</script>

<style lang="scss" module>
    .pagination {
        margin: 10px 0 0;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        line-height: 26px;
    }

    .paginationText {
        margin: 0 20px;
    }

    .paginationButton {
        cursor: pointer;
        width: 26px;
        text-align: center;
        transition: background-color .2s ease-in-out,color .2s ease-in-out, box-shadow 200ms ease
    }

    .paginationButton:hover {
        background: #57a3f3;
        color: #fff;
        &:hover {
            box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
        }
    }

    .filter {
        margin: -10px 0 10px;
    }

    .filterItem {
        display: inline-block;
        margin: 0 15px 15px 0;
    }

    .filterItemCheckbox {
        flex-basis: auto;
        align-self: flex-start;
        margin-top: 13px;
    }
</style>
